import { TabPanel, Tabs } from '@paypalcorp/pp-react'
import React, { useState } from 'react'

import useTracking from '../../hooks/useTracking'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'
import { TAB_SWITCHER_DATA } from '../../utils/prop-type-shape'

import './tab-switcher.less'

function TabSwitcher(props) {
  const { name, tabsInfo, renderTabContent, articleId } = props
  const [selectedTabIdx, setSelectedTabIdx] = useState(0)
  const { trackClick } = useTracking()

  const onTabClickHandler = (_, tabIndex) => {
    if (tabIndex === selectedTabIdx) {
      return
    }
    const { componentName, exp } = tabsInfo[tabIndex].tabProps
    trackClick({
      name: componentNames.TAB_SWITCHER,
      type: fptiTypes.ON_CLICK,
      help_doc_id: articleId,
      exp,
      link: `${componentNames.TAB_SWITCHER}|${articleId}|${componentName}`,
    })
    setSelectedTabIdx(tabIndex)
  }

  const renderTabs = () => {
    let tabsProps = []
    if (Array.isArray(tabsInfo)) {
      tabsProps = tabsInfo.map((tab) => ({
        id: tab.id,
        panelId: `p-${tab.id}`,
        label: tab.label,
      }))
    }
    if (Array.isArray(tabsProps) && tabsProps.length) {
      return (
        <Tabs
          name={name}
          selectedTabIdx={selectedTabIdx}
          onClick={onTabClickHandler}
          tabs={tabsProps}
          className="hc_tab_switcher_tabs"
          tabClassName="hc_tab_switcher_tabs__btn"
        >
          {tabsInfo.map(({ id, tabProps }) => (
            <TabPanel
              className="hc_tab_switcher_tab__content"
              key={id}
              id={`tab-panel-${id}`}
              tabId={`p-${id}`}
            >
              {renderTabContent(tabProps)}
            </TabPanel>
          ))}
        </Tabs>
      )
    }
    return null
  }

  return renderTabs()
}

TabSwitcher.propTypes = TAB_SWITCHER_DATA

export default TabSwitcher
